/** オフラインデータアップロード結果 */
export enum OFFLINE_UPLOAD_RESULT_CODE {
  /** 成功 */
  SUCCESS = 0,
  /** ネットワークエラー */
  NETWORK_ERROR = 1,
  /** 未完了エラー */
  INCOMPLETE_PROCESSING_ERROR = 2,
  /** 予期せぬエラー */
  UNEXPECTED_ERROR = 3
}
